var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cssVars)},[_c('div',{staticClass:"badge-container"},[_c('span',[_vm._v(_vm._s(_vm.useClientMnemonic))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }